import { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/NewDashboard.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { AppContext } from "../../../AppProvider";
import ToogleButton from "../../../controls/ToogleButton";
import { DashboardContext } from "./DashboardProvider";
const NewDashboard = ({showNewDashboardWindow,setShowNewDashboardWindow,setDashboardsFetched}) =>{
    const {user} = useContext(AppContext);
    const {selectedTenantAdminProfile} = useContext(DashboardContext);
    const [dashboardTitle,setDashboardTitle] = useState('');
    const [dashboardDescription,setDashboardDescription] = useState('');
    const [dashboardAssignedCustomers,setDashboardAssignedCustomers] = useState([]);
    const [customerSearchTerm,setCustomerSearchTerm] = useState('');
    const [hideDashboardInMobile,setHideDashboardInMobile] = useState(false);
    const [dashboardMobileOrder,setDashboardMobileOrder] = useState('');
    const [customers,setCustomers] = useState([]);
    const [showCustomersBrowser,setShowCustomersBrowser] = useState(false);
    const [dashboardImage,setDashboardImage] = useState(null);
    const dashboardImageInputRef = useRef();
    const fetchCustomers = async() =>{
        if(!selectedTenantAdminProfile) return;
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomers(responseData);
            }
        }
        catch(error){
            console.log('An error occurred when retrieving customers: ',error);
        }
    };
    const createDashboard = async() =>{
        try{
            const newDashboardModel = {
                title:dashboardTitle,
                description:dashboardDescription,
                customerIds:dashboardAssignedCustomers && dashboardAssignedCustomers.length > 0?
                            dashboardAssignedCustomers.map((dashboardAssignedCustomer) =>(
                                dashboardAssignedCustomer?.local?.id
                            )):[],
                mobileHide:hideDashboardInMobile,
                mobileOrder:dashboardMobileOrder,
                dashboardImage:dashboardImage
            }
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(newDashboardModel)
            });
            if(response.ok){
                setDashboardsFetched(false);
                setShowNewDashboardWindow(false);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(error);
        }
    };
    const resetNewDashboardFields = () =>{
      try{
        setDashboardTitle('');
        setDashboardDescription('');
        setDashboardAssignedCustomers([]);
        setCustomerSearchTerm('');
        setHideDashboardInMobile(false);
        setDashboardMobileOrder('');
        setCustomers([]);
        setShowCustomersBrowser(false);
        setDashboardImage(null);
      }
      catch(error){
        console.error('An error occurred when resetting dashboard fields',error);
      } 
    };
    const uploadDashboardImage = (e) =>{
        const file = e.target.files?.[0];
        if(!file) return;
        const maxSizeInBytes = 3.5 * 1024 ** 2;
        if(file.size > maxSizeInBytes){
            const sizeInMB = file.size / (1024 ** 2);
            const sizeInKB = file.size / 1024;
            const displaySize = sizeInMB > 0.5
                ? `${sizeInMB.toFixed(2)} MB`
                : `${sizeInKB.toFixed(2)} KB`;
            window.alert(`File is too large. Maximum allowed size is 3.5 MB\nYour file size is ${displaySize}`);
            e.target.value = null;
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () =>{
            setDashboardImage({
                name:file.name,
                size:file.size,
                image:reader.result.split(',')[1]
            });
        }
        reader.readAsDataURL(file);
    };
    useEffect(() =>{
        fetchCustomers();
        resetNewDashboardFields();
    },[showNewDashboardWindow]);
    if(!showNewDashboardWindow || !selectedTenantAdminProfile) return null;
    return (
        <div className="new-dashboard-parent-container">
            <div className="new-dashboard-container">
                <div className="new-dashboard-header">
                    <h3>Add dashboard</h3>
                    <p onClick={() => {
                        setShowNewDashboardWindow(false);
                    }}>&#10006;</p>
                </div>
                <div className="new-dashboard-body">
                    <div className="new-dashboard-property-component">
                        <p>Title<span>*</span></p>
                        <input
                            placeholder="Enter the dashboard title"
                            value={dashboardTitle}
                            onChange={(e) => setDashboardTitle(e.target.value)}
                        />
                    </div>
                    <div className="new-dashboard-property-component">
                        <p>Description</p>
                        <input
                            placeholder="Enter the dashboard description"
                            value={dashboardDescription}
                            onChange={(e) => setDashboardDescription(e.target.value)}
                        />
                    </div>
                    <div className="new-dashboard-property-component">
                        <p>Assigned customers</p>
                        <div className="assigned-customers-entry-container">
                            {dashboardAssignedCustomers.map((dashboardAssignedCustomer) =>(
                                <div key={dashboardAssignedCustomer?.id?.id} className="customer-entry">
                                    {dashboardAssignedCustomer?.external?.name}
                                    <p onClick={() =>{
                                        setDashboardAssignedCustomers(prev =>prev.filter(c => c.id?.id !== dashboardAssignedCustomer.id?.id))
                                    }}>&#10005;</p>
                                </div>
                            ))}
                            <input
                                placeholder="Select customers"
                                value={customerSearchTerm}
                                onChange={(e) => setCustomerSearchTerm(e.target.value)}
                                onFocus={() => setShowCustomersBrowser(true)}
                                onBlur={() =>{
                                    setTimeout(() =>{
                                        setShowCustomersBrowser(false);
                                    },200);
                                }}
                            />
                        </div>
                        <div className={`customers-browser-container ${showCustomersBrowser? 'active':''}`}>
                            {customers && customers.length > 0 && 
                            customers
                            .filter(c => 
                                c?.external?.name?.toLowerCase().includes(customerSearchTerm?.toLowerCase()) &&
                                !dashboardAssignedCustomers.some(assigned => assigned?.local?.id === c?.local?.id))
                                .sort((a,b) => a?.external?.name.localeCompare(b?.external?.name)).map((customer) =>(
                                <div key={customer?.local?.id} onClick={() =>{
                                        setCustomerSearchTerm('');
                                        setDashboardAssignedCustomers(prev => [...prev,customer]);
                                    }}>
                                    {customer?.external?.name}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="new-dashboard-mobile-settings-container">
                        <h4>Mobile application settings</h4>
                        <div className="hide-dashboard-container">
                            <ToogleButton
                                isToogled={hideDashboardInMobile}
                                onChange={() => setHideDashboardInMobile(!hideDashboardInMobile)}
                                size="40px"
                                marginTop="4px"
                                marginRight="12px"
                            />
                            <p>Hide dashboard in mobile application</p>
                        </div>
                        <div className="new-dashboard-property-component">
                            <p>Dashboard order in mobile application</p>
                            <div className="mobile-order-entry-container">
                                <input
                                    type="number"
                                    max={1000000}
                                    min={-1000000}
                                    value={dashboardMobileOrder}
                                    onKeyDown={(e) =>{
                                        if(e.key === '.' || e.key === 'e') e.preventDefault();
                                    }}
                                    onChange={(e) =>{
                                        const value = e.target.value;
                                        if(value === '') setDashboardMobileOrder('');
                                        else if(!isNaN(Number(value))) setDashboardMobileOrder(Number(value));
                                    }}
                                />
                            </div>
                        </div>
                        <div className="dashboard-image-container">
                            <p className="header">Dashboard image</p>
                            <div className="body">
                                <div className="image-container">
                                    <img
                                        style={{display:dashboardImage && dashboardImage?.image? 'block':'none'}}
                                        src={dashboardImage?.image? `data:image/png;base64,${dashboardImage?.image}`:null}/>
                                </div>
                                <div className={`upload-controls-container ${dashboardImage && dashboardImage?.image? 'inactive':''}`}
                                    onClick={() => dashboardImageInputRef.current.click()}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        multiple={false}
                                        style={{display:'none'}}
                                        ref={dashboardImageInputRef}
                                        onChange={uploadDashboardImage}
                                    />
                                    <img src={`${process.env.PUBLIC_URL}/images/gallery-icon.png`}/>
                                    <p>Browse from gallery</p>
                                </div>
                                <div className={`uploaded-controls-container ${dashboardImage && dashboardImage?.image? '':'inactive'}`}>
                                    <div>
                                        <p className="image-name-p">{dashboardImage?.name}</p>
                                        <p className="image-size-p">{
                                            dashboardImage?.size && (dashboardImage.size > 1024 ** 2 ?
                                                `${(dashboardImage.size / (1024 ** 2)).toFixed(2)} MB`:
                                                `${(dashboardImage.size / 1024).toFixed(2)} KB`
                                            )
                                        }</p>
                                    </div>
                                    <p className="remove-image-p" onClick={() => setDashboardImage(null)}>&#10005;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="new-dashboard-container-buttons">
                    <button onClick={() => {
                        setShowNewDashboardWindow(false);
                    }}>Cancel</button>
                    <button
                        title={!(dashboardTitle?.length > 0)? 'Dashboard title cannot be blank':''}
                        className={`${dashboardTitle?.length > 0? '':' inactive'}`}
                        aria-disabled={!(dashboardTitle?.length > 0)}
                        onClick={async() => {
                            if(!(dashboardTitle?.length > 0)) return;
                            await createDashboard()
                        }}>Add
                    </button>
                </div>
            </div>
        </div>
    );
};
export default NewDashboard;